/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTabBarProps } from './type';

export const tabBarDefaultProps: TdTabBarProps = {
  bordered: true,
  fixed: true,
  placeholder: false,
  safeAreaInsetBottom: true,
  shape: 'normal',
  split: true,
  theme: 'normal',
  zIndex: 1,
};
